var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{attrs:{"to":_vm.url}},[_c('b-icon',{staticClass:"navbar-item-icon",attrs:{"icon":_vm.icon,"pack":"fas"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }